import * as dates from "react-big-calendar/lib/utils/dates";

export interface Accessors<T> {
  start: (event: T) => Date;
  end: (event: T) => Date;
}

/**
 * Determines whether an event falls (at least partially) within the [start, end] range.
 *
 * @param e - The event object.
 * @param start - The start of the range.
 * @param end - The end of the range.
 * @param accessors - Functions to extract start/end dates from the event.
 * @returns True if the event overlaps the range.
 */
export function inRange<T>(
  e: T,
  start: Date,
  end: Date,
  accessors: Accessors<T>,
): boolean {
  const eStart = dates.startOf(accessors.start(e), "day");
  const eEnd = accessors.end(e);

  // Event starts on or before the range end
  const startsBeforeEnd = dates.lte(eStart, end, "day");

  // Event ends after the range start.
  // For zero-duration events, use >=; otherwise use >
  const endsAfterStart = !dates.eq(eStart, eEnd, "minutes")
    ? dates.gt(eEnd, start, "minutes")
    : dates.gte(eEnd, start, "minutes");

  return startsBeforeEnd && endsAfterStart;
}

export default inRange;
